import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import Image from 'marketing-website/components/modules/Image';
import Tag from 'marketing-website/components/modules/Tag';

import styles from './style/card.module.css';

export default function Card({ title, description, previewImage, path, tags }) {
  return (
    <div className={styles.card}>
      <Link to={path}>
        <div className={styles.preview}>
          <div className={styles.previewImage}>
            <Image hasShadow={false} src={previewImage} alt={title} />
          </div>
        </div>
      </Link>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
      <div className={styles.tags}>
        {tags.map(tag => (
          <div className={styles.tag} key={tag.id}>
            <Tag>{tag}</Tag>
          </div>
        ))}
      </div>
    </div>
  );
}

Card.propTypes = {
  title: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  tags: PropTypes.array.isRequired,
  description: PropTypes.string.isRequired,
  previewImage: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./src/pages/examples/_Card.js